import SystemInfoEndpoint from './endpoints/SystemInfoEndpoint';
import HttpService from '~/zf/frontend/common/http/HttpService';
async function getCommissioningDate(systemId) {
    const { data } = await HttpService.get(SystemInfoEndpoint.COMMISSIONING_DATE, { params: { systemId } });
    return data;
}
const SystemInfoService = {
    getCommissioningDate,
};
export default SystemInfoService;
